import AppConfig from "../../AppConfig";
import {
    ActivityIndicator, Modal, TouchableWithoutFeedback, View
} from "../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import Styles from "../../Styles";
import * as MaskFunctions from "@chocostack/maskifier";
import InfoItem from "./InfoItem";
import {BorderlessButton, DarkButton, ThemeButton} from "../../custom-packages/react-button-package/ButtonPackage";
import {RegisterEvent} from "../../AnalyticsFunctions";
import {useEffect, useState} from "react";
import {useStripe} from "@stripe/react-stripe-js";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {GoogleOAuthProvider} from "@react-oauth/google";
import GoogleSignIn from "../../custom-packages/sign-in-button/GoogleSignIn";
import {AppleAuthHandler, GetAuthObject, GoogleAuthHandler} from "../../authentication/AuthFunctions";
import * as AuthActions from "../../store/actions/authActions";
import AppleSignInWrapper from "../../custom-packages/sign-in-button/AppleSignInWrapper";

// @ts-ignore
import positiveSSL from "../../assets/landingpage/PositiveSSL_SectigoTag_72dpi.png";
// @ts-ignore
import stripewordmark from "../../assets/landingpage/Stripewordmark-blurple(small).png";
import ChocoForm from "../../custom-packages/react-chocoforms/typescript/models/ChocoForm";
import ChocoControl from "../../custom-packages/react-chocoforms/typescript/models/ChocoControl";
import ChocoValidation from "../../custom-packages/react-chocoforms/typescript/models/ChocoValidation";
import ChocoFormTS from "../../custom-packages/react-chocoforms/typescript/ChocoFormTS";

export const TSubscriptionItem = {
    "enUS": {
        CANCEL_ANY_TIME: "You can cancel anytime",
        NOT_INCLUDED: "Not Included:",
        SIGN_IN_EMAIL: "Sign In With Email",
        MONTHLY: "/ Month",
        FREE_PLAN_COST: 'Completely free!',
        TO_CONTINUE: 'To continue please Sign In',
        SIGNING_IN: 'Signing In...',
        TERMS_OF_SERVICE: 'By creating an account you are agreeing to our <a href="/TermsOfService" target="_blank" style="font-size: 14px;">Terms of Service</a>',

        //SHARED WITH ALL SUSCRIPTIONS
        'UNLIMITED_SCANS': 'No scanning limits for your QR code',
        'UNLIMITED_SCANS_DESC': 'Your QR code has no limit, no matter how many times it is scanned',
        'UNLIMITED_CATEGORIES': 'Unlimited Categories',
        'UNLIMITED_CATEGORIES_DESC': 'Add the categories you need, no limits',
        'UNLIMITED_FOOD': 'Unlimited Dishes',
        'UNLIMITED_FOOD_DESC': 'Add the dishes you need, no limits',
        'SUBSCRIBE': 'Subscribe',

        'CONFIRM_EMAIL_TITLE': 'Email Confirmation',
        'CONFIRM_EMAIL_TITLE_DESC': '<strong>Will not be used for marketing.</strong><br /> Will only be used to send bills, account/subscription related emails and technical support',
        'EMAIL': 'Email',
        'CANCEL': 'Cancel',
        'CONFIRM': 'Confirm',
        'UNEXPECTED_ERROR': 'Unexpected error, try again later',
    },
    "esMX": {
        CANCEL_ANY_TIME: "Puedes cancelar en el momento que quieras",
        NOT_INCLUDED: "No Incluido:",
        SIGN_IN_EMAIL: "Acceder con Correo Electrónico",
        MONTHLY: "/ Mes",
        FREE_PLAN_COST: '¡Completamente gratis!',
        TO_CONTINUE: 'Para continuar inicia sesión',
        SIGNING_IN: 'Iniciando Sesión...',
        TERMS_OF_SERVICE: 'Al crear una cuenta aceptas nuestros <a href="/TermsOfService" target="_blank" style="font-size: 14px;">Términos de Uso</a>',

        //SHARED WITH ALL SUSCRIPTIONS
        'UNLIMITED_SCANS': 'Sin límites de escaneos para tu código QR',
        'UNLIMITED_SCANS_DESC': 'Tu código QR no tiene límite, no importa cuántas veces sea escaneado',
        'UNLIMITED_CATEGORIES': 'Categorías Ilimitadas',
        'UNLIMITED_CATEGORIES_DESC': 'Agrega las categorías que necesites, no hay límites',
        'UNLIMITED_FOOD': 'Platillos Ilimitados',
        'UNLIMITED_FOOD_DESC': 'Agrega los platillos que necesites, no hay límites',
        'SUBSCRIBE': 'Suscríbete',

        'CONFIRM_EMAIL_TITLE': 'Confirma tu Correo',
        'CONFIRM_EMAIL_TITLE_DESC': '<strong>No será utilizado con fines de marketing.</strong><br /> Se utilizará solamente para envío de facturas, correos relacionados con el estado de tu cuenta/suscripción y soporte técnico',
        'EMAIL': 'Correo',
        'CANCEL': 'Cancelar',
        'CONFIRM': 'Confirmar',
        'UNEXPECTED_ERROR': 'Error inesperado, intente de nuevo más tarde',
    }
};

const SubscriptionItem = ({code, subName, items, otherItems = [], excludedItems = [], freeTrialText}) => {
    const stripe = useStripe();
    let Auth = GetAuthObject()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [creatingCheckout, setCreatingCheckout] = useState(false);

    const [pricing, setPricing] = useState<any>(false);
    const [priceID, setPriceID] = useState<any>(false);

    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [confirmingEmail, setConfirmingEmail] = useState(false);

    const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
    const [signingIn, setSigningIn] = useState(false);

    const [emailForm, setEmailForm] = useState<ChocoForm>(new ChocoForm({
        email: new ChocoControl({
            label: TSubscriptionItem[AppConfig.lang].EMAIL,
            elementConfig: {
                placeholder: TSubscriptionItem[AppConfig.lang].EMAIL
            },
            value: '',
            validation: new ChocoValidation({
                isEmail: true,
                required: true
            })
        })
    }))
    const [emailErrorMsg, setEmailErrorMsg] = useState<string>('')

    const gtag_report_conversion = (url) => {
        var callback = function () {
            if (typeof (url) !== 'undefined') {
                window.location = url;
            }
        };

        // @ts-ignore
        window.gtag('event', 'conversion', {
            'send_to': 'AW-850564176/pBhFCOCuudQYENCoypUD',
            'event_callback': callback
        });

        return false;
    }

    const createCheckoutSession = async (id) => {
        if (Auth.sub)
            return;

        // @ts-ignore
        gtag_report_conversion()

        setCreatingCheckout(true)
        const formData = new FormData();

        formData.append('price_id', id);

        const response = await fetch(AppConfig.URL + '/Subscription/CheckoutSession/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': Auth.token
                },
                // @ts-ignore
                body: new URLSearchParams(formData)
            }
        );

        if (response.ok) {
            const json = await response.json();
            const sessionId = json.sessionId;

            // @ts-ignore
            await stripe.redirectToCheckout({sessionId: sessionId});
        } else {
            console.error('Error:', response.statusText);
        }
        setCreatingCheckout(false)
    }

    const confirmEmail = async () => {
        const response = await fetch(AppConfig.URL + '/Account/ChangeEmail/?email=' + emailForm.controls['email'].value, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': Auth.token
                },
            }
        );

        if (response.ok) {
            const json = await response.json();

            if(json.success){
                createCheckoutSession(priceID)

                Auth.email = emailForm.controls['email'].value

                Auth = GetAuthObject({ user: Auth })

                setIsEmailModalOpen(false)

                try {
                    RegisterEvent({
                        source: window.location.href,
                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                        token: Auth.token,
                        action: 'CHECKOUT_EMAIL_CONFIRMED'
                    })
                } catch (e) {
                    console.log(e)
                }
            } else {
                if(json.msg)
                    setEmailErrorMsg(json.msg)
                else
                    setEmailErrorMsg(TSubscriptionItem[AppConfig.lang].UNEXPECTED_ERROR)
            }
        } else {
            setEmailErrorMsg(TSubscriptionItem[AppConfig.lang].UNEXPECTED_ERROR)
            console.error('Error:', response.statusText);
        }
    }


    useEffect(() => {
        const f = async () => {
            const fetchPricing = async () => {
                const response = await fetch(AppConfig.URL + '/Subscription/FetchPricing/?SubscriptionCode=' + code, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': Auth.token
                        },
                    }
                );

                let data = await response.json();

                return data;
            }

            if (code !== AppConfig.SUB_FREE) {
                const pricingData = await fetchPricing();

                if (pricingData.success) {
                    setPriceID(pricingData.priceID);
                    setPricing(pricingData.pricing);

                    setLoading(false)
                }
            }
        }

        f()
    }, [])

    return <div
        className="card mt-3"
        style={{
            height: '100%',
        }}
    >
        <div
            className={
                'subscription-header '
                + (code === AppConfig.SUB_BASIC ? 'basic-subscription-header' : '')
                + (code === AppConfig.SUB_STANDARD ? 'standard-subscription-header' : '')
            }>
            {subName}
        </div>
        <div className={'card-body'}
             style={{position: 'relative'}}
        >
            {
                code === AppConfig.SUB_FREE ?
                    <div style={{fontSize: '1.5rem', textAlign: 'center', ...Styles.themeSecondaryColor}}>
                        {TSubscriptionItem[AppConfig.lang].FREE_PLAN_COST}
                    </div>
                    :
                    loading ?
                        <div>
                            <ActivityIndicator size={25}/>
                        </div>
                        :
                        <div style={{
                            margin: '1rem 0',
                            fontSize: '1.7rem',
                            textAlign: 'center', ...Styles.themeSecondaryColor
                        }}>
                            {MaskFunctions.maskMoney(pricing.spR_PRICE)}
                            {' '}
                            {pricing.spR_CURRENCY}
                            {' ' + TSubscriptionItem[AppConfig.lang].MONTHLY}
                        </div>
            }
            <InfoItem
                title={'✔ ' + TSubscriptionItem[AppConfig.lang].UNLIMITED_SCANS}
                text={TSubscriptionItem[AppConfig.lang].UNLIMITED_SCANS_DESC}
            />
            <InfoItem
                title={'✔ ' + TSubscriptionItem[AppConfig.lang].UNLIMITED_CATEGORIES}
                text={TSubscriptionItem[AppConfig.lang].UNLIMITED_CATEGORIES_DESC}
            />
            <InfoItem
                title={'✔ ' + TSubscriptionItem[AppConfig.lang].UNLIMITED_FOOD}
                text={TSubscriptionItem[AppConfig.lang].UNLIMITED_FOOD_DESC}
            />
            {
                otherItems.map(item => <InfoItem
                    // @ts-ignore
                    icon={item.icon}
                    // @ts-ignore
                    title={item.title}
                    // @ts-ignore
                    text={item.text}
                />)
            }
            {
                items.map(item => <InfoItem
                    titleStyle={{fontWeight: 'bold', ...Styles.basicColor}}
                    icon={item.icon}
                    title={item.title}
                    text={item.text}
                />)
            }
            {
                excludedItems.length > 0 ?
                    <div
                        style={{fontSize: 16, marginTop: '1.5rem'}}
                    >
                        {TSubscriptionItem[AppConfig.lang].NOT_INCLUDED}
                    </div>
                    :
                    null
            }
            {
                excludedItems.map(item => <InfoItem
                    titleStyle={{color: '#AAAAAA'}}
                    // @ts-ignore
                    icon={item.icon}
                    // @ts-ignore
                    title={item.title}
                    // @ts-ignore
                    text={item.text}
                />)
            }
            <div
                style={{
                    display: 'flex',
                    backgroundColor: 'white',
                    padding: 30,
                }}
                className={'trust-seals'}
            >
                <img src={positiveSSL} className={'positiveSSL'} style={{objectFit: 'contain'}}/>
                <img src={stripewordmark} className={'stripe'} style={{objectFit: 'contain'}}/>
            </div>
            <div style={{height: 100}}></div>
            <div
                style={{position: 'absolute', bottom: 15, left: 15, right: 15}}
            >
                <div>
                    {
                        code === AppConfig.SUB_FREE ?
                            <BorderlessButton
                                disabled={creatingCheckout}
                                text={
                                    creatingCheckout ?
                                        <ActivityIndicator size={33} color={'black'}/>
                                        :
                                        freeTrialText
                                }
                                onPress={() => {
                                    RegisterEvent({
                                        source: window.location.href,
                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                        token: Auth.token,
                                        action: 'FINISH'
                                    })

                                    if (Auth && Auth.token) {
                                        if (Auth.defaultMenuID)
                                            navigate('/admin/menus/editor/' + Auth.defaultMenuID)
                                        else
                                            navigate('/admin/menus')

                                    } else
                                        setIsSignInModalOpen(true)
                                }}
                                style={{textAlign: 'center'}}
                            />
                            :
                            null
                    }
                    {
                        code === AppConfig.SUB_BASIC ?
                            <DarkButton
                                disabled={loading || creatingCheckout}
                                text={
                                    creatingCheckout ?
                                        <ActivityIndicator size={33} color={'black'}/>
                                        :
                                        TSubscriptionItem[AppConfig.lang].SUBSCRIBE
                                }
                                onPress={() => {
                                    RegisterEvent({
                                        source: window.location.href,
                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                        token: Auth.token,
                                        action: 'BASIC_CHECKOUT'
                                    })

                                    if (Auth && Auth.token)
                                        createCheckoutSession(priceID)
                                    else
                                        setIsSignInModalOpen(true)
                                }}
                                style={{
                                    padding: 10,
                                    textAlign: 'center',
                                    backgroundColor: '#f0234c'
                                }}
                                textStyle={{
                                    fontSize: 22,
                                    fontWeight: 'bold'
                                }}
                            />
                            :
                            null
                    }
                    {
                        code === AppConfig.SUB_STANDARD ?
                            <ThemeButton
                                disabled={loading || creatingCheckout}
                                text={
                                    creatingCheckout ?
                                        <ActivityIndicator size={33} color={'black'}/>
                                        :
                                        TSubscriptionItem[AppConfig.lang].SUBSCRIBE
                                }
                                onPress={() => {
                                    RegisterEvent({
                                        source: window.location.href,
                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                        token: Auth.token,
                                        action: 'STANDARD_CHECKOUT'
                                    })

                                    if (Auth && Auth.token) {
                                        if (Auth.email?.search(/privaterelay.appleid.com/i) != -1)
                                            setIsEmailModalOpen(true)
                                        else
                                            createCheckoutSession(priceID)
                                    } else
                                        setIsSignInModalOpen(true)
                                }}
                                style={{
                                    padding: 10,
                                    textAlign: 'center',
                                    backgroundColor: Styles.standardBackgroundColor.color
                                }}
                                textStyle={{
                                    fontSize: 22,
                                    fontWeight: 'bold'
                                }}
                            />
                            :
                            null
                    }
                    <div style={{fontSize: '1.1rem', textAlign: 'center', marginTop: '.5rem'}}>
                        {TSubscriptionItem[AppConfig.lang].CANCEL_ANY_TIME}
                    </div>
                </div>
            </div>
        </div>
        <Modal
            visible={isEmailModalOpen}
            onRequestClose={() => setIsEmailModalOpen(false)}
            hideHeader={true}
            footer={<View
                style={{
                    flexDirection: 'row',
                    justifyContent: 'flex-end'
                }}
            >
                {
                    !confirmingEmail ?
                        <BorderlessButton
                            text={TSubscriptionItem[AppConfig.lang].CANCEL}
                            onPress={() => setIsEmailModalOpen(false)}
                        />
                        :
                        null
                }
                <View style={{width: 7}}></View>
                <ThemeButton
                    disabled={!emailForm.isValidForm || confirmingEmail}
                    text={confirmingEmail ?
                        <ActivityIndicator size={23} color={'white'}/> : TSubscriptionItem[AppConfig.lang].CONFIRM}
                    onPress={async () => {
                        setConfirmingEmail(true)

                        await confirmEmail()

                        setConfirmingEmail(false)
                    }}
                />
            </View>}
        >
            <h1>
                {TSubscriptionItem[AppConfig.lang].CONFIRM_EMAIL_TITLE}
            </h1>
            <div
                dangerouslySetInnerHTML={{ __html: TSubscriptionItem[AppConfig.lang].CONFIRM_EMAIL_TITLE_DESC }}
                style={{
                    textAlign: 'justify',
                    marginTop: 10,
                    marginBottom: 20,
                    fontSize: '1.1rem'
                }}
            ></div>
            <ChocoFormTS
                form={emailForm}
                onFormChange={(updatedForm) => {
                    setEmailForm(updatedForm)
                }}
            />
            {
                emailErrorMsg ?
                    <div
                        className={'alert alert-danger'}
                    >
                        {emailErrorMsg}
                    </div>
                    :
                    null
            }
        </Modal>
        <Modal
            visible={isSignInModalOpen}
            onRequestClose={() => setIsSignInModalOpen(false)}
        >
            {
                signingIn ?
                    <View
                        style={{
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 15
                        }}
                    >
                        <span style={{marginBottom: 15}}>{TSubscriptionItem[AppConfig.lang].SIGNING_IN}</span>
                        <ActivityIndicator/>
                    </View>
                    :
                    <View>
                        <div style={{
                            fontSize: '1.5rem',
                            textAlign: 'center',
                            marginBottom: 15,
                            fontWeight: 'bold',
                            ...Styles.themeColor
                        }}>
                            {TSubscriptionItem[AppConfig.lang].TO_CONTINUE}
                        </div>
                        <GoogleOAuthProvider
                            clientId="311231473058-g5ra5hhgep2qai2pk3t6ej8015lcedid.apps.googleusercontent.com"
                        >
                            <GoogleSignIn
                                onClick={async (credentialResponse) => {
                                    RegisterEvent({
                                        source: window.location.href,
                                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                        token: Auth.token,
                                        action: 'CLICK_GOOGLE_SIGN_IN_BUTTON'
                                    })

                                    try {
                                        setSigningIn(true);

                                        const response = await GoogleAuthHandler(credentialResponse)

                                        if (response && response.auth) {
                                            dispatch(AuthActions.saveAuth(response.auth))

                                            Auth = response.auth

                                            if (code !== AppConfig.SUB_FREE)
                                                createCheckoutSession(priceID)
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    } finally {
                                        setIsSignInModalOpen(false)
                                        setSigningIn(false);
                                    }
                                }}
                            />
                        </GoogleOAuthProvider>
                        <div style={{height: 10}}></div>
                        <AppleSignInWrapper
                            redirectUri={'https://tastee.app'}
                            onClick={async (appleResponse) => {
                                RegisterEvent({
                                    source: window.location.href,
                                    sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                    token: Auth.token,
                                    action: 'CLICK_APPLE_SIGN_IN_BUTTON'
                                })

                                try {
                                    setSigningIn(true);

                                    const response = await AppleAuthHandler(appleResponse)

                                    if (response && response.auth) {
                                        dispatch(AuthActions.saveAuth(response.auth))

                                        Auth = response.auth

                                        if (code !== AppConfig.SUB_FREE)
                                            createCheckoutSession(priceID)
                                    }
                                } catch (e) {
                                    console.error(e);
                                } finally {
                                    setIsSignInModalOpen(false)
                                    setSigningIn(false);
                                }
                            }}
                        />
                        <div style={{height: 10}}></div>
                        <TouchableWithoutFeedback
                            to={'/auth?type=BUSINESS'}
                            style={{
                                padding: 10,
                                backgroundColor: 'white',
                                border: '1px solid #CCCCCC',
                                fontSize: 18,
                                borderRadius: 4
                            }}
                        >
                            {TSubscriptionItem[AppConfig.lang].SIGN_IN_EMAIL}
                        </TouchableWithoutFeedback>
                        <div style={{height: 10}}></div>
                        <div
                            dangerouslySetInnerHTML={{__html: TSubscriptionItem[AppConfig.lang].TERMS_OF_SERVICE}}
                            style={{textAlign: 'center', fontSize: 14}}
                        >
                        </div>
                    </View>
            }
        </Modal>
    </div>
}

export default SubscriptionItem;